import { BranchingQueryDefinition, getChildEdgeTypeId } from '@iotv/datamodel-core';
import { AdjacentType, ComparisonType, LogicalOperatorType } from '@iotv/iotv-v3-types';
export const getSourceEntities = (source, entityType) => {
    let sourceType = source.type;
    const apexQuery = new BranchingQueryDefinition({
        id: 'apex',
        path: [{ adjacencyType: AdjacentType.SUBJECT, objectTypeId: sourceType }],
        subQueries: [],
    });
    const sourceToGroupQuery = new BranchingQueryDefinition({
        id: 'sourceToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId(sourceType, 'Group'), // 'group_has_area', //
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: entityType,
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToGroupQuery = new BranchingQueryDefinition({
        id: 'groupToGroupQuery',
        path: [
            {
                objectTypeId: 'Group',
                adjacencyType: AdjacentType.PARENT,
                edgeTypeId: getChildEdgeTypeId('Group', 'Group'),
                nodeFilters: [
                    {
                        filters: [
                            {
                                key: 'supportedType',
                                predicate: ComparisonType.EQUALS,
                                value: entityType,
                            },
                        ],
                        setOperation: LogicalOperatorType.AND,
                    },
                ],
            },
        ],
        subQueries: [],
    });
    const groupToEntityQuery = new BranchingQueryDefinition({
        id: 'groupToEntityQuery',
        path: [
            {
                objectTypeId: entityType,
                adjacencyType: AdjacentType.CHILD,
                edgeTypeId: getChildEdgeTypeId('Group', entityType),
            },
        ],
        subQueries: [],
    });
    apexQuery.addSubQuery(sourceToGroupQuery);
    sourceToGroupQuery.addSubQuery(groupToGroupQuery);
    groupToGroupQuery.addSubQuery(groupToGroupQuery);
    groupToGroupQuery.addSubQuery(groupToEntityQuery);
    sourceToGroupQuery.addSubQuery(groupToEntityQuery);
    const res = {
        query: apexQuery,
        dehydrated: apexQuery.dehydrate(),
    };
    return res;
};
